import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {TenantService} from './tenant.service';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {EmailGroup} from '../models/email-group.model';
import { Auth, idToken } from '@angular/fire/auth';


@Injectable({
  providedIn:'root'
})
export class NewsletterService {
  private http = inject(HttpClient);
  private tenant = inject(TenantService);
  private afAuth = inject(Auth);


  private authJwtToken:string;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
    const afAuth = this.afAuth;


    idToken(afAuth).subscribe(jwt => this.authJwtToken = jwt);

  }

  addToNewsletter(email:string): Observable<any> {
    return this.http.post<any>(
      environment.api.newsletterUrl,
      {
        tenantId: this.tenant.id,
        email
      });
  }

  loadEmailGroups(emailProviderId:string, apiKey:string): Observable<EmailGroup[]> {

    const params = new HttpParams()
      .set("emailProviderId", emailProviderId)
      .set("apiKey", apiKey);

    return this.http.get<EmailGroup[]>(
      `${environment.api.newsletterUrl}/email-groups`, {params});
  }

  downloadAllEmails() {

    window.open(environment.api.downloadEmailsUrl + `?idToken=${this.authJwtToken}`);

  }

}
